import { useSelector } from 'react-redux';

/**
 * @author Karen Yunuen Pozos Arias
 * @jobTitle Full Stack Developer - IBL
 * @email kpozos@ibl.mx
 *
 * React hook-like function that centralizes access to global state (Redux)
 * and provides logic for switching subviews and managing selection state.
 *
 * @param {Function} setSubView - Function to update the current subview.
 * @param {Array} selectedList - Currently selected elements.
 * @param {Function} setSelectedList - Function to clear or update selected elements.
 *
 * @param {Function} setFinalArray - Function to reset or update the final array of search criteria used for advanced filtering.
 * @param {Function} setSearchElement - Function to reset or update the text input used for simple search.
 * @returns {Object} Object containing:
 * - {boolean} DEV - Current development mode flag from Redux state.
 * - {Array|string|Object} permission - User permission data from Redux state.
 * - {Function} handleSubViewChange - Function to switch subviews and reset selection if needed.
 */
const InvitationMainApp = ({ setSubView, selectedList, setSelectedList, setFinalArray, setSearchElement }) => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const handleSubViewChange = (view) => {
        if (selectedList?.length > 0) setSelectedList([]);
        setSubView(view);
        setFinalArray([]);
        setSearchElement("");
    };

    return {
        DEV,
        permission,
        handleSubViewChange
    };
};

export default InvitationMainApp;
